// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"273":"76c3c759","518":"783fbbff"}[chunkId] + ".css";
};